import React from 'react';
import type { VendorKey } from '../../../../Constants';
import { normalizeLossesVendor } from '../../../../Constants';
import { applyLossesVendor } from '../../../../pre-contract/lib/preContractPartnerLosses';
import { postPciLossesVendorToEmbed } from '../../../../pre-contract/lib/preContractEmbedBridge';
import { useViewerStore } from '../../../../store/store';
import SiteReportPopup from '../Modal/Modal-Content/SiteReportPopup';
import { persistLossesSource } from './persistLossesSource';

export { persistLossesSource } from './persistLossesSource';

export function openLossesSiteReport(sceneViewer: any): void {
    sceneViewer?.viewerAlert?.({
        show: true,
        title: 'Download Site Report',
        message: <SiteReportPopup />,
        messageType: 'info',
        isModal: true,
    });
}

/**
 * Same Confirm / Generate path as LossesVendorSection → ToggleLossesConfirm.
 * Writes Losses Source, applies the vendor (embed + local viewer), then optionally
 * opens the site report.
 */
export function confirmLossesVendor(vendor: VendorKey, isGenerate: boolean): void {
    const target = normalizeLossesVendor(vendor);
    persistLossesSource(target);
    applyLossesVendor(target, { force: true });

    if (!isGenerate) return;

    const sceneViewer = useViewerStore.getState().sceneViewer;
    if (sceneViewer) {
        openLossesSiteReport(sceneViewer);
        return;
    }
    postPciLossesVendorToEmbed(target, { force: true, generate: true });
}
